<div
  *ngIf="!loading"
  class="px-3 pt-7 pb-8">
  <p class="font-medium text-2xl">Выберите способ доставки</p>

  <div class="flex justify-content-center mt-5 gap-8">
    <crm-button
      type="button"
      label="SMS-рассылка"
      style="min-width: 150px !important; max-width: 150px !important"
      styleClass="p-button-lg"
      (onClick)="selectChannel(MailingChannelEnum.SMS)"></crm-button>

    <crm-button
      type="button"
      label="Email-рассылка"
      style="min-width: 150px !important; max-width: 150px !important"
      styleClass="p-button-lg"
      (onClick)="selectChannel(MailingChannelEnum.EMAIL)"></crm-button>
  </div>
</div>

<crm-spinner
  *ngIf="loading"
  top="mt-4"></crm-spinner>
